import React from 'react';
import { connect } from 'react-redux';
import { ISession } from '../../models/pro-sites';
import { AuthProvider } from './auth-context';
import { RootState } from '../../store';

interface AuthProps {
    session: ISession;
    children: JSX.Element;
}

const Auth = ({ session, children }: AuthProps) => {
    return (
        <AuthProvider value={{ buckets: session.userBuckets }}>
            {children}
        </AuthProvider>
    );
};

const mapStateToProps = (state: RootState) => {
    return {
        session: state.session!.data!,
    };
};

const mapDispatchToProps = {};

const authContainer = connect(mapStateToProps, mapDispatchToProps)(Auth);

export default authContainer;
